import { useEffect, useState } from 'react';
import MenuComponent from '../component/MenueComponent';
import { MyFooter } from '../landingpage/MyFooter';

type IErgebnisse = {
  position: number,
  name: string,
  verein: string,
  startnummer: string,
  time: string,
  sekunden: number,
  formatiert: string,
}

type IKategorien = {
  name: string,
  text: string,
  start: string,
  Ergebnisse: IErgebnisse[]
}

type ISatz = {
  ereignisname: string,
  Kategorien: IKategorien[],
}

export function Rangliste() {

  const [data, setData] = useState<ISatz[]>([]);

  const getData = () => {
    fetch(process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_PATH! + "/restGetRangliste.rest", {
      method: 'get',
    })
      .then(resp => resp.json())
      .then(setData)
      .catch((e) => console.log(e));
  }

  const getDifferenz = (date1: string, date2: string) => {

    const start = new Date(date1);
    const end = new Date(date2);

    const diffMs = end.getTime() - start.getTime(); // Millisekunden
    const totalSeconds = Math.floor(diffMs / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Hilfsfunktion zum Formatieren mit führenden Nullen
    const pad = (n: number) => String(n).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {/*<MyHeader />*/}

      <div className="max-w-7xl mx-auto">

        <MenuComponent aktuelleseite="rangliste" />

        <p className="max-w text-center text-2xl mt-4">Rangliste</p>

        {data.length === 0 &&
          <p className="max-w text-center text-xl mt-4">Momentan ist keine Rangliste öffentlich</p>
        }

        {data.map((e) => <>
          <h3 style={{ textAlign: "center", width: "100%" }}>{e.ereignisname}</h3>

          {e.Kategorien.map((k) => <>
            <legend>{k.text}</legend>

            <table className="table">

              <tr>
                <th>Position</th>
                <th>Startnummer</th>
                <th>Name</th>
                <th>Team</th>
                <th>Laufzeit</th>
              </tr>

              {k.Ergebnisse.map((t) => <>
                <tr>
                  <td>{t.position}</td>
                  <td>{t.startnummer}</td>
                  <td>{t.name}</td>
                  <td>{t.verein}</td>
                  <td>{getDifferenz(k.start, t.time)}</td>
                </tr>
              </>)}

            </table >
          </>)}
        </>)}

        <MyFooter />

      </div >
    </>
  );
}

export default Rangliste;